import { Phone, Mail, ArrowUpRight } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";

export const ContactCTA = () => {
  const ref = useReveal();
  return (
    <section
      id="contact"
      data-testid="contact-cta-section"
      className="bg-[#F3F0EA]"
    >
      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 py-20 md:py-20 lg:py-28">
        <div ref={ref} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-end">
          <div className="lg:col-span-7">
            <p className="eyebrow-rule text-[11px] uppercase tracking-[0.28em] text-[#4A4D4A] mb-6">
              <span>06 · Get in touch</span>
            </p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-[3.25rem] leading-[1.1] tracking-[-0.02em] text-[#1A1C1A] font-medium">
              Start with a{" "}
              <em className="italic font-normal text-[#1B2E26]">
                free 15-minute call
              </em>
              .
            </h2>
            <p className="mt-8 text-[#4A4D4A] text-lg md:text-xl leading-relaxed max-w-2xl">
              No commitment, no expectation. Just a conversation to see whether
              we&rsquo;re a good fit and whether what I offer is right for what
              you&rsquo;re looking for.
            </p>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-4">
            <a
              href="tel:07501211348"
              data-testid="contact-phone-button"
              className="group flex items-center justify-between gap-4 bg-[#1B2E26] text-[#FDFBF7] hover:bg-[#2C453B] px-7 py-6 transition-colors"
            >
              <div className="flex items-center gap-4">
                <Phone size={20} strokeWidth={1.6} />
                <div>
                  <p className="text-[10px] uppercase tracking-[0.24em] opacity-80">
                    Phone
                  </p>
                  <p className="font-serif-display text-2xl leading-none mt-1">
                    07501 211 348
                  </p>
                </div>
              </div>
              <ArrowUpRight
                size={20}
                strokeWidth={1.6}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
            <a
              href="mailto:ghoshchandril@gmail.com"
              data-testid="contact-email-button"
              className="group flex items-center justify-between gap-4 border border-[#1B2E26] text-[#1B2E26] hover:bg-[#1B2E26] hover:text-[#FDFBF7] px-7 py-6 transition-colors"
            >
              <div className="flex items-center gap-4">
                <Mail size={20} strokeWidth={1.6} />
                <div>
                  <p className="text-[10px] uppercase tracking-[0.24em] opacity-80">
                    Email
                  </p>
                  <p className="font-serif-display text-xl md:text-2xl leading-none mt-1 break-all">
                    ghoshchandril@gmail.com
                  </p>
                </div>
              </div>
              <ArrowUpRight
                size={20}
                strokeWidth={1.6}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
